const styles = theme => ({
  root: {
    background: '#fafafa',
    padding: '50px 10%',
    minHeight: '100vh',
    // padding: '50px',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      padding: '50px 20px',
    },
  },
  header1: {
    fontSize: '2.75rem',
    textAlign: 'center',
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
      textAlign: 'left',
    },
  },
  spacingBottom: {
    marginBottom: '50px',
  },
  slides: {
    padding: '0 50px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px',
    },
  },
  arrowIcon: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '999',
    background: '#F9701F',
    '&:hover': {
      background: '#F9701F',
      opacity: '0.8',
    },
  },
  prevArrow: {
    left: '0',
  },
  nextArrow: {
    right: '0',
  },
});

export default styles;
